import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { PageContext, useApi } from '@axiom/ui';

import DefaultLayout from '../layouts/default';
import { OpportunitiesList } from '../components/OpportunitiesList/OpportunitiesList';
import { OpportunityFilters } from '../components/OpportunityFilters/OpportunityFilters';
import { UserSettingsUtil } from '../utils/user-settings-util';
import { UserApi } from '../api/user-api';

/**
 * @param {{ name?: string }} props
 */
export const OpportunitiesPage = ({ name } = {}) => {
  const { setTitle } = useContext(PageContext);
  setTitle('Opportunities List');
  const [{ data: user }] = useApi(UserApi.readSessionUser());
  return (
    <DefaultLayout
      sidebarContent={<OpportunityFilters />}
      hideSideDrawer={UserSettingsUtil.shouldShowNewOpportunityTalentView(
        user.settings
      )}
    >
      <OpportunitiesList />
    </DefaultLayout>
  );
};

OpportunitiesPage.propTypes = {
  name: PropTypes.string,
};
